export default "__VITE_ASSET__BjBZxQKr__"